import { ColDef } from "ag-grid-enterprise";

type Props = {
	OnEdit?: Function;
	OnSend?: Function;
};

export const useGridDefinitions = ({ OnEdit, OnSend }: Props) => {
	const defaultColDef: ColDef = {
		flex: 1,
		filter: false,
		floatingFilter: false,
		sortable: false,
		editable: false,
		resizable: false,
		wrapText: false,
		autoHeight: false,
		wrapHeaderText: true,
		suppressHeaderMenuButton: true,
		cellStyle: {
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
		},
	};

	return {
		defaultColDef,
	};
};
